// extracted by mini-css-extract-plugin
module.exports = {"emneknagger":"dhsg3rFwK-emneknagger","emneknagger__wrapper":"dhsgZK3Zk-emneknagger__wrapper","emneknaggerWrapper":"dhsgZK3Zk-emneknagger__wrapper"};